import React from "react";

interface KredafiLogoProps {
  className?: string;
  size?: number;
  theme?: "light" | "dark";
  onClick?: () => void;
  /** Сдвиг влево: в PNG lockup слева ~15% прозрачного поля */
  opticalAlign?: boolean;
}

/**
 * Готовый PNG от владельца: знак K + KredaFi + слоган.
 * Файл не перерисовываем и не кропаем.
 */
const KredafiLogo: React.FC<KredafiLogoProps> = ({
  className = "",
  size = 48,
  theme = "light",
  onClick,
  opticalAlign = false,
}) => {
  const isDark = theme === "dark";
  const src = isDark
    ? "/assets/kredafi-lockup-official-dark.png?v=kf20260909_v3"
    : "/assets/kredafi-lockup-official.png?v=kf20260909_v3";

  return (
    <span
      className={`kf-logo ${isDark ? "kf-logo-dark" : ""} ${
        opticalAlign ? "kf-logo-optical" : ""
      } ${className}`.trim()}
      onClick={onClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        cursor: onClick ? "pointer" : "default",
        userSelect: "none",
        lineHeight: 1,
        flexShrink: 0,
        ...(opticalAlign
          ? ({ "--kf-lockup-size": `${size}px` } as React.CSSProperties)
          : {}),
      }}
    >
      <img
        src={src}
        alt="KredaFi"
        height={size}
        style={{
          display: "block",
          height: size,
          width: "auto",
          maxWidth: "100%",
          objectFit: "contain",
        }}
      />
    </span>
  );
};

export default KredafiLogo;
